import { render, staticRenderFns } from "./LearnerDetail.vue?vue&type=template&id=024f644a"
import script from "./LearnerDetail.vue?vue&type=script&lang=js"
export * from "./LearnerDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports